// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type Receipt24CircleFilledProps = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const Receipt24CircleFilled: FC<Receipt24CircleFilledProps> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="32"
            height="32"
        >
            <path
                d="M16 32c8.837 0 16-7.163 16-16S24.837 0 16 0 0 7.163 0 16s7.163 16 16 16Zm-8-8.504V24h16V9.714a1.65 1.65 0 0 0-.504-1.21A1.65 1.65 0 0 0 22.286 8H9.714a1.65 1.65 0 0 0-1.21.504A1.65 1.65 0 0 0 8 9.714v13.782Zm12.571-2.925h-6.857v-1.714h6.857v1.714Zm0-3.714H11.43v-1.714h9.142v1.714Zm0-3.714H11.43v-1.714h9.142v1.714Z"
                fillRule="evenodd"
                clipRule="evenodd"
            />
        </svg>
    );
};

export default Receipt24CircleFilled;
